<template>
	<SmartLayoutC compId="home_wrapper" :mode="homeMode" />
</template>

<script>
export default {
	name: 'DynamicHome'
};
</script>
<script setup>
import { computed, onMounted, inject } from 'vue';
import SmartLayoutC from '@rebuild/components/SmartLayoutC.vue';
import { useStore } from '@/utils/vue-api';
import { IRSTORE_T_VIEW } from '@/utils/track';
import { resolveStoreId, resolvePageId } from '@rebuild/utils/context';
import { TEMPLATE_TITLE_MAP } from '@/store';

const store = useStore();
const isMobileMode = computed(() => store.getters.isMobileMode);
const homeMode = computed(() => {
	return isMobileMode.value ? 'mob-basic' : 'basic';
});

const templateType = inject('TEMPLATE_TYPE');
const getTemplateType = computed(() => templateType?.value || '');
const addViewTrack = () => {
	const homeTitle = TEMPLATE_TITLE_MAP[getTemplateType.value] || '首页';
	const params = {
		浏览模块名称: homeTitle,
		浏览模块类型: '系统默认模块',
		企业ID: resolveStoreId(),
		页面ID: resolvePageId()
	};
	IRSTORE_T_VIEW(282, { params });
};
onMounted(() => {
	addViewTrack();
});
</script>
